var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"examine-all"},[_c('el-dialog',{attrs:{"title":_vm.title,"align":"center","visible":_vm.dialogVisible,"width":"90%","close-on-click-modal":false,"before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticClass:"media-box",attrs:{"id":"media-box"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }